var flattenObject = function(obj) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return Object.keys(obj).reduce(function(acc, key) {
        var nestedPath = prefix.length ? "".concat(prefix, ".") : "";
        if (typeof obj[key] === "object") {
            Object.assign(acc, flattenObject(obj[key], nestedPath + key));
        } else {
            acc[nestedPath + key] = obj[key];
        }
        return acc;
    }, {});
};
export default flattenObject;

//# sourceMappingURL=flattenObject.js.map